import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
} from 'axios';
import {
  APP_ERRORS,
  BACKEND_RESPONSE_STATUS,
  SERVER_ERRORS,
} from '../constants/backendResponse';
import store from '../store';
import allActions from '../store/actions';
import { getAuth0AccessToken } from '../utils/authService';
import { clearLocalStorage, clearSessionStorage } from '../utils/sessionUtils';
import { loginPath } from '../utils/paths';

class Api {
  constructor() {
    const service: AxiosInstance = axios.create({
      headers: {},
      responseType: 'json',
    });
    service.interceptors.response.use(this.handleSuccess, this.handleError);
    service.interceptors.request.use(this.setAuthToken);

    this.service = service;
  }

  service;

  private setAuthToken = (config: AxiosRequestConfig): AxiosRequestConfig => {
    const token = getAuth0AccessToken();
    if (token) {
      return {
        ...config,
        headers: {
          ...config.headers,
          Authorization: token,
        },
      };
    }
    return config;
  };

  handleSuccess = (response: AxiosResponse): any => {
    return response.data;
  };

  handleError = (error: AxiosError) => {
    const status = error.request?.status;

    if (status === 401 || status === 0) {
      clearLocalStorage();
      store.dispatch(
        allActions.appConfigActions.setServerError(SERVER_ERRORS.UNAUTHORIZED),
      );
      window.location.href = `/${loginPath}`;
    }

    if (status === 400) {
      const data = error?.response?.data;

      if (data?.statusReason === BACKEND_RESPONSE_STATUS.QUOTA_EXCEEDED) {
        store.dispatch(
          allActions.appConfigActions.setAppError(APP_ERRORS.QUOTA_EXCEEDED),
        );
        store.dispatch(allActions.appConfigActions.setLoader(false));

        // store.dispatch(allActions.appConfigActions.setServerError(SERVER_ERRORS.BAD_REQUEST));
      }

      // else if(data.statusReason === BACKEND_RESPONSE_STATUS.USER_ACCOUNT_NOT_APPROVED) {
      //   // This condition is working from here when form session token is already generated and the user perform the login
      //   store.dispatch(allActions.appConfigActions.setAppError(APP_ERRORS.USER_ACCOUNT_NOT_APPROVED));
      //    store.dispatch(allActions.appConfigActions.setLoader(false));

      //   }
      else if (data.status === BACKEND_RESPONSE_STATUS.VALIDATION_ERROR) {
        //  store.dispatch(allActions.appConfigActions.setAppError(APP_ERRORS.FORM_NOT_AVAILABLE));
        store.dispatch(
          allActions.appConfigActions.setServerError(
            SERVER_ERRORS.VALIDATION_ERROR,
          ),
        );
        store.dispatch(allActions.appConfigActions.setLoader(false));

        // return data;
      } else if (
        data.statusReason === BACKEND_RESPONSE_STATUS.USER_ACCOUNT_NOT_APPROVED
      ) {
        store.dispatch(
          allActions.appConfigActions.setAppError(
            APP_ERRORS.USER_ACCOUNT_NOT_APPROVED,
          ),
        );
        store.dispatch(allActions.appConfigActions.setLoader(false));
      } else if (
        data.statusReason === BACKEND_RESPONSE_STATUS.USER_ACCOUNT_REJECTED
      ) {
        store.dispatch(
          allActions.appConfigActions.setAppError(
            APP_ERRORS.USER_ACCOUNT_REJECTED,
          ),
        );
        store.dispatch(allActions.appConfigActions.setLoader(false));
      }else if (
        data.statusReason ===
        BACKEND_RESPONSE_STATUS.USER_ACCOUNT_DISABILITY_CATEGORY_MISMATCH
      ) {
        store.dispatch(
          allActions.appConfigActions.setAppError(
            APP_ERRORS.USER_ACCOUNT_DISABILITY_CATEGORY_MISMATCH,
          ),
        );
        store.dispatch(allActions.appConfigActions.setLoader(false));
      }

      //
      else if (data?.validationResponse) {
        store.dispatch(
          allActions.appConfigActions.setAppError(
            APP_ERRORS.FORM_NOT_AVAILABLE,
          ),
        );
        return data;
      } else {
        //  store.dispatch(allActions.appConfigActions.setAppError(APP_ERRORS.FORM_NOT_AVAILABLE));
        //   return data;
      }
      store.dispatch(allActions.appConfigActions.setLoader(false));

      // store.dispatch(allActions.appConfigActions.setServerError(SERVER_ERRORS.BAD_REQUEST));
    }

    if (status === 404 || status === 412) {
      store.dispatch(
        allActions.appConfigActions.setServerError(SERVER_ERRORS.NOT_FOUND),
      );
      store.dispatch(allActions.appConfigActions.setLoader(false));
    }

    if (status === 500) {
      store.dispatch(
        allActions.appConfigActions.setServerError(
          SERVER_ERRORS.SERVER_UNAVAILABLE,
        ),
      );
      store.dispatch(allActions.appConfigActions.setLoader(false));
    }
    return Promise.reject(error);
  };

  get(path: string, params?: any, headers?: any): Promise<any> {
    return this.service
      .request({
        method: 'GET',
        url: path,
        params: { ...(params ?? {}) },
        headers: { ...(headers ?? {}) },
      })
      .then((response) => response);
  }

  patch(path: string, payload: any): Promise<any> {
    return this.service
      .request({
        method: 'PATCH',
        url: path,
        data: payload,
      })
      .then((response) => response);
  }

  post(path: string, payload: any, headers?: any): Promise<any> {
    return this.service
      .request({
        method: 'POST',
        url: path,
        data: payload,
        headers: { ...(headers ?? {}) },
      })
      .then((response) => response);
  }

  put(path: string, payload: any, headers?: any): Promise<any> {
    return this.service
      .request({
        method: 'PUT',
        url: path,
        data: payload,
        headers: { ...(headers ?? {}) },
      })
      .then((response) => response);
  }

  delete(path: string, headers?: any): Promise<any> {
    return this.service
      .request({
        method: 'DELETE',
        url: path,
        headers: { ...(headers ?? {}) },
      })
      .then((response) => response);
  }
}

export default new Api();
